const siteData = {
  navigationLinksList: ["Home", "Specialisms", "Vacancies", "About Us", "Contact Us"],
  projectsList: "hello",
  locations: ["Bristol", "London", "Liverpool", "USA", "Manchester"],
};

export default siteData;
